/**
 * Ms. Flo — wajah hero landing.
 * Aset dari DFA KARAKTER MAKER; jangan kompres ulang, jangan bangkitkan visual baru.
 */
export const MS_FLO_ALT = "Ms. Flo — karakter AI Peak Performance Indonesia";
export const MS_FLO_LABEL = "Karakter AI";

export function MsFlo({ className }: { className?: string }) {
  return (
    <figure
      className={className}
      data-ms-flo=""
      style={{
        position: "relative",
        margin: 0,
        flexShrink: 0,
        width: "min(280px, 42vw)",
        maxWidth: "100%",
      }}
    >
      <img
        src="/karakter/ms-flo-diam.jpg"
        srcSet="/karakter/ms-flo-diam.jpg 1x, /karakter/ms-flo-diam@2x.jpg 2x"
        alt={MS_FLO_ALT}
        width={600}
        height={804}
        decoding="async"
        style={{
          display: "block",
          width: "100%",
          height: "auto",
          borderRadius: 18,
          objectFit: "cover",
        }}
      />
      {/* Label AI wajib terbaca — bukan title/tooltip/aria-hidden. */}
      <figcaption
        style={{
          position: "absolute",
          left: 10,
          bottom: 10,
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: "0.04em",
          color: "#0a0a0a",
          background: "rgba(255,255,255,0.92)",
          border: "1px solid rgba(0,0,0,0.12)",
          borderRadius: 6,
          padding: "4px 8px",
          lineHeight: 1.2,
        }}
      >
        {MS_FLO_LABEL}
      </figcaption>
    </figure>
  );
}
